export default __webpack_public_path__ + "static/media/text-blue.7c63f443.svg";